import { ModelsProps } from 'types/reduxTypes/models';

export const getInitialState = (): ModelsProps => ({
  loadingModelId: ''
});
